// Version : 0.0.1
// Author : VISHAL,ARANVINDHAN,VISHNU
// LastEdit : SHIYAM
// Last ADD : Changed the Token Name , Added command lines for export functions
// MODFIED DATE : 01-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

// EXPORT FUNCTION OF GET ECONOMIC ACTIVITY LIST
export const economicActivityListGet = (listData: any) => {
	const data = {
		GetEconomicActivityListToken: listData,
	};
	const url = `${API_URL}getEconomicActivityList`;
	return makeApiCall(url, data);
};

// EXPORT FUNCTION OF DELETE ECONOMIC ACTIVITY LIST
export const economicActivityDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteEconomicActivityDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteEconomicActivityDetails`;
	return makeApiCall(url, data);
};

// EXPORT FUNCTION OF ADD ECONOMIC ACTIVITY LIST
export const economicActivityDetailsAdd = (addData: any) => {
	const data = {
		AddEconomicActivityDetailsToken: addData,
	};
	const url = `${API_URL}addEconomicActivityDetails`;
	return makeApiCall(url, data);
};

// EXPORT FUNCTION OF UPDATE ECONOMIC ACTIVITY LIST
export const economicActivityDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateEconomicActivityDetailsToken: updateData,
	};
	const url = `${API_URL}updateEconomicActivityDetails`;
	return makeApiCall(url, data);
};

// EXPORT FUNCTION OF FETCH ECONOMIC ACTIVITY LIST
export const economicActivityDetailsFetch = (fetchData: any) => {
	const data = {
		FetchEconomicActivityDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchEconomicActivityDetails`;
	return makeApiCall(url, data);
};
